import { RouteObject, createBrowserRouter } from 'react-router'

import { createStore } from 'zustand'

import { filterAuthorizedConfigs } from '../../../utils/filterAuthorizeConfigs'
import { filterRestrictedResources } from '../../../utils/filterRestrictedResources'
import { filterRoutes } from '../../../utils/filterRoutes'
import { filterVisibleResources } from '../../../utils/filterVisibleResources'
import { transformConfigs } from '../../../utils/transformConfigs'
import { transformResources } from '../../../utils/transformResources'

import { RouterStore, RouterOptions } from './interface'

const resolveRoutes = (
  items: RouterOptions['items'],
  hasPermission: RouterOptions['hasPermission']
) => {
  const allConfigs = transformConfigs(items)
  const allRoutes = filterRoutes(allConfigs)
  const allResources = transformResources(allConfigs)

  const authorizedConfigs = filterAuthorizedConfigs(allConfigs, hasPermission)

  const authorizedRoutes = filterRoutes(authorizedConfigs)
  const authorizedResources = transformResources(authorizedConfigs)
  const restrictedResources = filterRestrictedResources(authorizedResources)

  const visibleResources = filterVisibleResources(authorizedResources)

  return {
    allConfigs,
    allRoutes,
    allResources,
    restrictedResources,
    authorizedRoutes,
    visibleResources
  }
}

export const createRouterStore = ({
  items,
  basename,
  hasPermission
}: RouterOptions) =>
  createStore<RouterStore>(() => {
    const { authorizedRoutes, ...rest } = resolveRoutes(items, hasPermission)

    return {
      ...rest,
      authorizedRoutes,
      router: createBrowserRouter(authorizedRoutes as RouteObject[], {
        basename
      })
    }
  })
